import { render, staticRenderFns } from "./custom-insert-tag-widget.vue?vue&type=template&id=3679f746&"
import script from "./custom-insert-tag-widget.vue?vue&type=script&lang=js&"
export * from "./custom-insert-tag-widget.vue?vue&type=script&lang=js&"
import style0 from "./custom-insert-tag-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports